export const reverseTranslateCondition = (value) => {
  const reverseMap = {
    "=": "equals",
    "!=": "not-equals",
    contains: "contains",
    "not contains": "not-contains",
    ">": "greater-than",
    "<": "less-than",
    ">=": "greater-than-or-equal",
    "<=": "less-than-or-equal",
  };

  // Return the mapped key or an empty string if it doesn't exist
  return reverseMap[value];
};
